/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `music_generate` - 음악 생성
 * `music_extend` - 음악 연장
 * `music_regenerate` - 트랙 재생성
 * `meta_playlist` - 플레이리스트 메타데이터
 * `meta_youtube_seo` - YouTube SEO 메타데이터
 * `meta_mv_scene` - 뮤직비디오 씬 프롬프트
 * `meta_agent_idea` - AI Agent 아이디어 생성
 * `image_thumbnail` - 썸네일 생성
 * `image_cover` - 플레이리스트 커버 생성
 * `image_hd` - 고화질 이미지 생성
 * `kling_5s_std` - Kling 5초 클립 (Standard)
 * `kling_5s_pro` - Kling 5초 클립 (Professional)
 * `kling_10s_std` - Kling 10초 클립 (Standard)
 * `kling_10s_pro` - Kling 10초 클립 (Professional)
 * `youtube_upload` - YouTube 업로드
 * `youtube_caption` - 자막 생성
 * `render_1080p` - 영상 렌더링 (1080p)
 * `render_2k` - 영상 렌더링 (2K)
 * `render_shorts` - Shorts 렌더링
 */
export type OperationTypeEnum =
  (typeof OperationTypeEnum)[keyof typeof OperationTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OperationTypeEnum = {
  music_generate: "music_generate",
  music_extend: "music_extend",
  music_regenerate: "music_regenerate",
  meta_playlist: "meta_playlist",
  meta_youtube_seo: "meta_youtube_seo",
  meta_mv_scene: "meta_mv_scene",
  meta_agent_idea: "meta_agent_idea",
  image_thumbnail: "image_thumbnail",
  image_cover: "image_cover",
  image_hd: "image_hd",
  kling_5s_std: "kling_5s_std",
  kling_5s_pro: "kling_5s_pro",
  kling_10s_std: "kling_10s_std",
  kling_10s_pro: "kling_10s_pro",
  youtube_upload: "youtube_upload",
  youtube_caption: "youtube_caption",
  render_1080p: "render_1080p",
  render_2k: "render_2k",
  render_shorts: "render_shorts",
} as const;
